export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--Z.bf897118.png";